import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { APP_API_URL } from '../../config/global.config';
import { APP_API_TAGS } from '../app.constants';
import { defaultErrorMsg, defaultHeaders } from '../app.utils';
import {
  clearOrganizationSession,
  isOrganizationSessionError,
} from '../features/auth/auth.slice';

export const appServiceApi = createApi({
  reducerPath: 'api-app',
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: APP_API_URL,
      prepareHeaders: async (headers, { getState }) => {
        const { access_token, sessionId } = (getState() as any)?.auth || {};
        return defaultHeaders(headers, access_token, sessionId);
      },
    });

    const result = await baseQuery(args, api, extraOptions);
    await defaultErrorMsg(result);

    // Expired or revoked organization session: drop it so boot sends the user
    // back to the organization picker.
    if (
      isOrganizationSessionError(result.error) &&
      (api.getState() as any)?.auth?.sessionId
    ) {
      api.dispatch(clearOrganizationSession());
    }

    return result;
  },

  tagTypes: Object.values(APP_API_TAGS),
  keepUnusedDataFor: 10,
  endpoints: () => ({}),
});
